function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#636363;fill-rule:evenodd;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-40 -530)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 25,
  height: 25,
  transform: "translate(40 530)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M11.39,1.283V9.077H15.3V1.283a1.954,1.954,0,0,0-3.908,0Zm-9.612,3.4a.674.674,0,0,1,.953-.953L3.1,4.1,4.294,2.908a2.085,2.085,0,1,0,.751,1.154L3.577,5.53a.674.674,0,0,1-.953,0ZM5.251,1.951,6.1,1.1a.674.674,0,0,1,.953.953l-.962.962a3.435,3.435,0,1,1-.837-1.069ZM-1.188,16.04a.674.674,0,0,0-.674.674.674.674,0,0,0,.674.674.674.674,0,0,0,.674-.674A.674.674,0,0,0-1.188,16.04Zm2.7,1.348a.674.674,0,0,1,0-1.348H8.021a.674.674,0,0,1,0,1.348Zm-2.7-4.043a.674.674,0,0,0-.674.674.674.674,0,0,0,.674.674.674.674,0,0,0,.674-.674A.674.674,0,0,0-1.188,13.344Zm2.7,1.348a.674.674,0,0,1,0-1.348H8.021a.674.674,0,1,1,0,1.348Zm9.883-4.268v9.883a.674.674,0,0,1-.674.674h-14.6a.674.674,0,0,1-.674-.674V1.215A3.239,3.239,0,0,1-1.323-2.019H13.344a3.31,3.31,0,0,1,3.3,3.3V9.75a.674.674,0,0,1-.674.674Zm-.7-11.1a3.282,3.282,0,0,0-.644,1.954V19.633H-3.209V1.215A1.891,1.891,0,0,1-1.323-.671ZM-1.188,10.649a.674.674,0,0,0-.674.674A.674.674,0,0,0-1.188,12a.674.674,0,0,0,.674-.674A.674.674,0,0,0-1.188,10.649ZM1.507,12H8.021a.674.674,0,0,0,0-1.348H1.507a.674.674,0,0,0,0,1.348Zm0,0",
  transform: "translate(46.557 533.019)"
}));

var SvgIcOrders = function SvgIcOrders(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcOrders, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_orders.a1146304.svg";
export { ForwardRef as ReactComponent };